export interface ActivityListOption {
  value: string;
  label: string;
}

export const ActivityListOptions: ActivityListOption[] = [
  {
    value: '23',
    label: 'AGROPECUÁRIO',
  },
  {
    value: '25',
    label: 'ALIMENTAÇÃO',
  },
  {
    value: '11',
    label: 'ARMAZENAGEM',
  },
  {
    value: '5',
    label: 'ASSESSORIAS',
  },
  {
    value: '28',
    label: 'CARTÕES',
  },
  {
    value: '20',
    label: 'COMBUSTÍVEIS',
  },
  {
    value: '10',
    label: 'COMUNICAÇÃO/IDENTIFICAÇÃO VISUAL',
  },
  {
    value: '6',
    label: 'CONCESSÕES/EXPLORAÇÃO/IMÓVEL',
  },
  {
    value: '32',
    label: 'CONFECÇÕES/DECORAÇÃO',
  },
  {
    value: '29',
    label: 'DIDÁTICO',
  },
  {
    value: '12',
    label: 'ELETRO ELETRÔNICOS/ÓTICA',
  },
  {
    value: '27',
    label: 'EMBALAGENS E LACRES',
  },
  {
    value: '38',
    label: 'ENGENHARIA - Materiais',
  },
  {
    value: '37',
    label: 'ENGENHARIA - Serviços',
  },
  {
    value: '7',
    label: 'EQUIPAMENTOS/FERRAMENTAS',
  },
  {
    value: '30',
    label: 'ESCRITÓRIO E GRÁFICA',
  },
  {
    value: '4',
    label: 'ESPECIALIZADOS',
  },
  {
    value: '13',
    label: 'ESPORTIVOS/MUSICAIS',
  },
  {
    value: '33',
    label: 'EVENTOS',
  },
  {
    value: '8',
    label: 'FERROVIÁRIOS',
  },
  {
    value: '36',
    label: 'FUNERÁRIA',
  },
  {
    value: '18',
    label: 'HOSPEDAGEM',
  },
  {
    value: '14',
    label: 'INFANTIL/ PLAYGROUND',
  },
  {
    value: '31',
    label: 'INFORMÁTICA',
  },
  {
    value: '2',
    label: 'INSTALAÇÕES',
  },
  {
    value: '217',
    label: 'Leilões',
  },
  {
    value: '35',
    label: 'MOBILIÁRIOS',
  },
  {
    value: '19',
    label: 'PASSAGENS',
  },
  {
    value: '9',
    label: 'PETROBRAS',
  },
  {
    value: '3',
    label: 'PRESTAÇÃO DE SERVIÇOS - Mão de Obra',
  },
  {
    value: '24',
    label: 'PRODUTOS DE LIMPEZA',
  },
  {
    value: '34',
    label: 'PUBLICIDADE',
  },
  {
    value: '21',
    label: 'QUÍMICOS',
  },
  {
    value: '22',
    label: 'SAÚDE',
  },
  {
    value: '15',
    label: 'SEGURANÇA /PROTEÇÃO',
  },
  {
    value: '16',
    label: 'SEGUROS',
  },
  {
    value: '26',
    label: 'SISTEMA DE VALES',
  },
  {
    value: '41',
    label: 'TRANSPORTES AÉREOS',
  },
  {
    value: '40',
    label: 'TRANSPORTES NÁUTICOS',
  },
  {
    value: '39',
    label: 'TRANSPORTES RODOVIÁRIOS',
  },
];
